// extracted by mini-css-extract-plugin
module.exports = {"mc":"character_mc__3ura6"};